import locale_ja from './ja.json';
import locale_en from './en.json';

const message = {
  'ja': locale_ja,
  'en': locale_en
}

export default (locale) => {
  const messageKeys = Object.keys(message);
  if (!messageKeys.includes(locale)) {
    locale = "ja";
  }
  return message["en"]
};